import { ERROR_CATEGORY, ALL_CATEGORY } from "../../components/DealList/BadCategoryOrTag";
export function getSelectedCategory(categories, categoryUrl) {
    if (!categoryUrl) {
        return ALL_CATEGORY;
    }
    var selected = categories.filter(function (item) { return item.url === categoryUrl; })[0];
    return selected || ERROR_CATEGORY;
}
export function getSelectedTags(category, tagsFromQuery) {
    if (!category) {
        return [];
    }
    var tags = category.tags;
    if (!tagsFromQuery) {
        return tags;
    }
    return tags.filter(function (tag) { return tagsFromQuery.indexOf(tag.url) > -1; });
}
